import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';
import { EndpointError } from '@/services/errorService';
import globalData from '@/store/globalData';

export const ENDPOINTS = deepFreeze({
    IMPORT: {
        URI: () => {
            if (globalData.user.isRoleAdmin) return '/api/v1/spaces/{{spaceId}}/producer-products/import';
            throw new EndpointError();
        },
        methods: ['post'],
    },
    PRODUCT: {
        URI: () => '/api/v1/producer-products/{{id}}',
        methods: ['get', 'patch'],
        cacheToClear: ['/api/v1/spaces/\\d+/products-price-chart'],
    },
    GROUPS: {
        URI: () => '/api/v1/producer-products/{{id}}/producer-product-groups',
        methods: ['get', 'patch'],
    },
    SALES_STATS: {
        URI: () => '/api/v1/producer-products/{{id}}/sales-stats',
        methods: ['get'],
    },
    CLICKS_STATS: {
        URI: () => '/api/v1/producer-products/{{id}}/clicks-stats',
        methods: ['get'],
    },
    IMPRESSIONS_STATS: {
        URI: () => '/api/v1/producer-products/{{id}}/impressions-stats',
        methods: ['get'],
    },
    SALES_CHART: {
        URI: () => '/api/v1/producer-products/{{id}}/sales-chart',
        methods: ['get'],
    },
    TRAFFIC_CHART: {
        URI: () => '/api/v1/producer-products/{{id}}/traffic-chart',
        methods: ['get'],
    },
    AVAILABILITY_CHART: {
        URI: () => '/api/v1/producer-products/{{id}}/availability-chart',
        methods: ['get'],
    },
    PRICE_CHART: {
        URI: () => '/api/v1/producer-products/{{id}}/price-chart',
        methods: ['get'],
    },
    OFFERS: {
        URI: () => '/api/v1/producer-products/{{id}}/offers',
        methods: ['get'],
    },
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
